function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.1.264A6.818,6.818,0,0,0,1.725,11.092L.17,12.761a.629.629,0,0,0,.461,1.058H6.9a7,7,0,0,0,7.09-6.52A6.824,6.824,0,0,0,6.1.264Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/comments.e1d07346.svg";
export { SvgComponent as ReactComponent };